<template>
  <div class="building-information text-left">
    <el-form
      :model="form"
      :rules="rules"
      :label-position="$root.screenWidth > 550 ? 'left' : 'top'"
      label-width="100px"
      ref="form"
    >
      <el-form-item :label="$t('text.name')" prop="OrganisationName">
        <el-input
          v-model="form.OrganisationName"
          :placeholder="$t('text.name')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('text.address')" prop="OrganisationAddress">
        <el-input
          v-model="form.OrganisationAddress"
          :placeholder="$t('text.address')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('text.phone')" prop="OrganisationContact">
        <el-input
          v-model="form.OrganisationContact"
          :placeholder="$t('text.phone')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('text.location')" prop="Location">
        <el-select
          v-model="form.Location"
          filterable
          :placeholder="$t('text.location')"
          class="wp-100"
        >
          <el-option
            v-for="item in countryList"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item :label="$t('text.time_zone')" prop="TimeZone">
        <el-select
          v-model="form.TimeZone"
          filterable
          :placeholder="$t('text.time_zone')"
          class="wp-100"
          :loading="fetchTimezoneLoading"
        >
          <el-option
            v-for="item in timeZoneList"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="IsDemo">
        <el-checkbox v-model="form.IsDemo">{{
          $t('text.demo_org_desc')
        }}</el-checkbox>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import swal from 'sweetalert'
import ApiService from '@/services/ApiService.js'
import countries from 'countries-list'
export default {
  data() {
    return {
      loading: false,
      fetchTimezoneLoading: false,
      timeZoneList: [],
      countryList: [],
      form: {
        OrganisationName: '',
        OrganisationAddress: '',
        OrganisationContact: '',
        Location: '',
        TimeZone: '',
        IsDemo: false
      },
      rules: {
        OrganisationName: [
          {
            required: true,
            message: this.$t('text.please_enter_organisation_name'),
            trigger: 'blur'
          }
        ],
        OrganisationAddress: [
          {
            required: true,
            message: this.$t('text.please_enter_organisation_address'),
            trigger: 'blur'
          }
        ],
        OrganisationContact: [
          {
            required: true,
            message: this.$t('text.please_enter_organisation_phone'),
            trigger: 'blur'
          }
        ],
        TimeZone: [
          {
            required: true,
            message: this.$t('text.please_select_time_zone'),
            trigger: 'blur'
          }
        ],
        Location: [
          {
            required: true,
            message: this.$t('text.please_select_location'),
            trigger: 'blur'
          }
        ]
      }
    }
  },
  watch: {
    loading() {
      this.$emit('loadingChange', this.loading)
    }
  },
  mounted() {
    this.getAllLocation()
    this.getCountryList()
  },
  methods: {
    getCountryList() {
      const countryCodes = Object.keys(countries.countries)
      this.countryList = countryCodes.map(
        code => countries.countries[code].name
      )
    },
    getAllLocation() {
      this.fetchTimezoneLoading = true
      ApiService.GetAllLocation()
        .then(response => {
          this.fetchTimezoneLoading = false
          this.timeZoneList = response.data.data
        })
        .catch(() => {
          this.fetchTimezoneLoading = false
        })
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.saveOrganisation()
        }
      })
    },
    saveOrganisation() {
      this.loading = true
      ApiService.SaveOrganisation({
        ...this.form,
        DomainName: document.domain
      })
        .then(response => {
          this.loading = false
          if (response.data.success) {
            // In invitation work flow, if user have no organisations, after create organisation, then remove invitation info
            let invitationInfo = localStorage.getItem('invitationInfo')
            if (invitationInfo) {
              localStorage.removeItem('invitationInfo')
              this.loading = true
              this.$store.dispatch('user/verifyUser').then(() => {
                this.loading = false
                this.$emit('createSuccess')
              })
            } else {
              this.$emit('createSuccess')
            }
          } else {
            swal({
              icon: 'error',
              timer: 2000,
              title: this.$t('text.failed'),
              text: response.data.msg
            })
          }
        })
        .catch(() => {
          this.loading = false
          swal({
            icon: 'error',
            timer: 2000,
            title: this.$t('text.failed')
          })
        })
    }
  }
}
</script>
